// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.9142 6.45208L12 1.59375L7.08581 6.45207L8.49191 7.87435L11 5.39477V12.504H13V5.39478L15.5081 7.87435L16.9142 6.45208Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.00003H2V22H22V2.00003H16.5V4.00003H20V14H4V4.00003H7.5V2.00003ZM8.00195 16.998V19.002H5.99805V16.998H8.00195ZM11.002 16.998V19.002H8.99805V16.998H11.002Z"}}]};

const UninstallFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'uninstall-filled',
    ref,
    icon: element,
  },
));

UninstallFilledIcon.displayName = 'UninstallFilledIcon';

export default UninstallFilledIcon;
